var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{staticClass:"app-button",attrs:{"variant":_vm.variant,"disabled":_vm.disabled,"block":_vm.block,"type":_vm.type},on:{"click":function($event){return _vm.$emit(_vm.appConstants.app.emitEvents.CLICK, $event)}}},[_vm._t("default",function(){return [[_vm._v(_vm._s(_vm.text))]]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }